<app-page-wrapper [className]={className}>


    <section class="HUD">
      <!-- Avatar container -->
      <div class="avatar-wrapper" *ngIf="!showLevelSelector">
        <app-avatar class="avatar-holder" *ngIf="appVersion === 'jijenik'"></app-avatar>
        <app-avatar2 class="avatar-holder" *ngIf="appVersion === 'broedels'"></app-avatar2>
      </div>

      <!-- Level select button -->
      <section class="logout-button" *ngIf="!showLevelSelector">
        <app-button (click)="logout();  audio.playSoundClick();">{{audio.text.dashboard.logout}}</app-button>
      </section>

      <!-- Bottom content-->
      <app-textblock (playClicked)="playBottomText(); audio.playSoundClick();" *ngIf="!showLevelSelector">
        <div [innerHTML]="bottomText"></div>

      </app-textblock>

      <!-- Level selector -->
      <section class="level-selector" *ngIf="showLevelSelector">
        <app-img-open-baggage #levelSelector (onLevelClick)="setLevel($event); audio.playSoundClick();"></app-img-open-baggage>
        <div class="level-selector-caption">
          <p>{{audio.text.dashboard.chooseItem}}</p>
        </div>
      </section>

    </section>

    <section class="roadmap-container" [ngClass]="{'openLevelSelector': showLevelSelector}" *ngIf="!showLevelSelector">
      <app-img-roadmap id="map" (onLevelSelectClick)="openLevelSelector(); audio.playSoundClick();"
        (onLevelClick)="setLevel($event); audio.playSoundClick();"></app-img-roadmap>
    </section>

    <app-button-back *ngIf="showLevelSelector" (onClick)="closeLevelSelector(); audio.playSoundClick();">
      {{audio.text.global.back}}
    </app-button-back>

    <app-button-liedje></app-button-liedje>

</app-page-wrapper>
